import React, { useEffect, useState } from "react";
import "./author.styles.scss";
import { Space, Divider, Tooltip, Row as AntRow, Col } from "antd";
import { ColumnType } from "antd/lib/table";
import CTable from "../../components/table/CTable";
import { QUERY_PARAM } from "../../constants/get-api.constant";
import { useSelectorRoot, useDispatchRoot } from "../../redux/store";
import Utils from "../../utils/base-utils";
import { 
    DeleteOutlined, 
    EditOutlined, 
    PlusOutlined,
    UserOutlined,
    FileTextOutlined,
    CalendarOutlined,
    CloseOutlined
} from "@ant-design/icons";
import { Form, Input, Button } from "antd";
import { motion } from "framer-motion";
import Modal from "antd/lib/modal/Modal";
import { ITranslator } from "../../common/translator.interface";
import { addTranslatorRequest, deleteAuthorRequest, getListAuthorsRequest, getListTranslatorRequest } from "../../redux/controller";
import moment from "moment";
import CModalEditTranslator from "../../components/modal/CModalEditTranslator";
import TextArea from "antd/lib/input/TextArea";
import { confirmCloseModal } from "../../components/modalEditBook/CModalConfirmClose";


const Translator = () => {
    const { totalAuthorsRecords, listTranslator } =
        useSelectorRoot((state) => state.management);

    const [textSearch, setTextSearch] = useState("");
    const [openModalAdd, setOpenModalAdd] = useState(false);
    const [openModalEdit, setOpenModalEdit] = useState(false);
    const [author, setAuthor] = useState()
    const [currentSearchValue, setCurrentSearchValue] =
        useState<any>({
            size: QUERY_PARAM.size,
            offset: 0,
        });
    const dispatch = useDispatchRoot();
    const [hasChanges, setHasChanges] = useState(false);
    const [form] = Form.useForm();
    const values = Form.useWatch([], form);

    useEffect(() => {
        // getAllTranslator()
        dispatch(getListTranslatorRequest(currentSearchValue));
    }, [dispatch, currentSearchValue]);



    useEffect(() => {
        const currentValues = form.getFieldsValue();
        const hasFormChanges = 
            currentValues.name !== "" ||
            currentValues.birthYear !== "" ||
            currentValues.description !== "";
        
        setHasChanges(hasFormChanges);
    }, [values, form]);

    const onChangePagination = (event: any) => {
        currentSearchValue.offset = (event - 1) * QUERY_PARAM.size;
        console.log(currentSearchValue);

        setCurrentSearchValue(currentSearchValue);
        dispatch(getListAuthorsRequest(currentSearchValue));
    };

    const onChangeInput = (event: any) => {
        setTextSearch(event.target.value);
    };

    const getAuthorName = (record: any) => {
        // Ưu tiên sử dụng trường name mới
        if (record.name) {
            return record.name;
        }
        
        // Fallback về format cũ để tương thích ngược
        let authorName = ""
        if (record.firstName) {
            authorName += record.firstName
        }
        if (record.middleName) {
            authorName += " " + record.middleName
        }
        if (record.lastName) {
            authorName += " " + record.lastName
        }
        return authorName || "Không có tên";
    }

    const columns: ColumnType<ITranslator>[] = [
        {
            title: "Số thứ tự",
            width: "120px",
            render: (_, __, rowIndex) =>
            (
                <div className="span-table" style={{ textAlign: "center" }}>
                    {currentSearchValue.offset + rowIndex + 1}
                </div>
            ),
        },
        {
            title: "Họ và tên",
            dataIndex: "fullName",
            key: "fullName",
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                    <div style={{ textAlign: "center" }} >{getAuthorName(record)}</div>
                </div>
            )
        },
        {
            title: "Thời gian tạo",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ textAlign: "center" }} >{moment(record.createdAt).format("DD/MM/YYYY HH:mm:ss")}</div>
                </div>
            ),
        },
        {
            title: 'Ngày sinh',
            dataIndex: 'birthday',
            key: 'birthday',
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ textAlign: "center" }} >{(record.birthday && record.birthday !== 'string') ? moment(new Date(record.birthday)).format("DD/MM/YYYY") : "Chưa cập nhật"}</div>
                </div>
            )
        },
        {
            title: 'Mô tả',
            dataIndex: 'description',
            key: 'description',
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ textAlign: "center" }} >{(record.description && record.birthday !== 'string') ? record.description : "Chưa cập nhật"}</div>
                </div>
            )
        },
        {
            title: "Thao tác",
            key: "action",
            render: (_, record) => (
                <Space size="middle" style={{ display: 'flex', justifyContent: 'center' }}>
                    <Tooltip placement="top" title={"Chỉnh sửa"} >
                        <EditOutlined onClick={(event) => handleEdit(record)} />
                    </Tooltip>
                    <Tooltip placement="top" title={"Xóa"}>
                        <DeleteOutlined 
                            style={{ color: '#ff4d4f', cursor: 'pointer' }} 
                            onClick={(event) => handleDelete(record)} 
                        />
                    </Tooltip>

                </Space>
            ),
        },
    ];

    const onSearch = () => {
        const body: any = {
            size: QUERY_PARAM.size,
            offset: 0,
            search: textSearch,
        };
        const finalBody = Utils.getRidOfUnusedProperties(body);
        setCurrentSearchValue(finalBody);
        dispatch(getListAuthorsRequest(finalBody));
    };

    const onCancelAddAuthor = () => {
        confirmCloseModal({
            hasChanges,
            onConfirm: () => {
                setOpenModalAdd(false);
                form.resetFields();
                setHasChanges(false);
            },
            title: 'Xác nhận đóng',
            content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal thêm dịch giả?'
        });
    }

    const handleAuthorChange = (event: { target: { value: any } }) => {
        // Handle form changes if needed
    };

    const onAdd = async (value: any) => {
        console.log(value);

        const bodyRequest = {
            name: value.name,
            description: value.description,
            birthYear: value.birthYear ? parseInt(value.birthYear) : undefined,
        }

        dispatch(addTranslatorRequest(bodyRequest))
        setOpenModalAdd(false)
        form.resetFields();
        setHasChanges(false);

    }

    const handleEdit = (record: any) => {
        const selectedTranslator: any = {
            id: record.id,
            name: record.name || getAuthorName(record),
            description: record.description,
            birthYear: record.birthYear,
        }
        setAuthor(selectedTranslator)
        setOpenModalEdit(true);
        console.log(selectedTranslator)
    };

    const handleDelete = (record: any) => {
        const bodyRequest = {
            id: record.id,
        }
        dispatch(deleteAuthorRequest(bodyRequest))
    };

    return (
        <motion.div
            className="sketch-main"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            {openModalAdd &&
                <Modal
                    open={openModalAdd}
                    onCancel={onCancelAddAuthor}
                    title={
                        <Space>
                            <PlusOutlined />
                            <span>Thêm dịch giả</span>
                        </Space>
                    }
                    className="translator-modal"
                    footer={null}
                    width={600}
                    destroyOnClose
                    maskClosable={true}
                >
                    <div className="modal-content">
                        <Form 
                            onFinish={onAdd}
                            form={form}
                            className="translator-form"
                            layout="vertical"
                        >
                            <AntRow gutter={[16, 12]}>
                                <Col span={24}>
                                    <Form.Item
                                        label={
                                            <Space>
                                                <UserOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                                <span>Tên đầy đủ dịch giả</span>
                                            </Space>
                                        }
                                        name="name"
                                        rules={[{ required: true, message: "Tên dịch giả không được để trống!" }]}
                                    >
                                        <Input
                                            placeholder="Nhập tên đầy đủ dịch giả (ví dụ: Dương Tường)"
                                            className="form-input"
                                            onChange={handleAuthorChange}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item
                                        label={
                                            <Space>
                                                <CalendarOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                                <span>Năm sinh</span>
                                            </Space>
                                        }
                                        name="birthYear"
                                        rules={[
                                            { 
                                                pattern: /^\d{4}$/, 
                                                message: "Năm sinh phải là 4 chữ số!" 
                                            },
                                            {
                                                validator: (_, value) => {
                                                    if (!value) return Promise.resolve();
                                                    const year = parseInt(value);
                                                    if (year < 1900 || year > new Date().getFullYear()) {
                                                        return Promise.reject(new Error('Năm sinh phải từ 1900 đến hiện tại!'));
                                                    }
                                                    return Promise.resolve();
                                                }
                                            }
                                        ]}
                                    >
                                        <Input
                                            placeholder="Nhập năm sinh (ví dụ: 1970)"
                                            className="form-input"
                                            onChange={handleAuthorChange}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <div style={{ height: '36px' }}></div>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label={
                                            <Space>
                                                <FileTextOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                                <span>Mô tả</span>
                                            </Space>
                                        }
                                        name="description"
                                    >
                                        <TextArea
                                            placeholder="Nhập mô tả"
                                            rows={4}
                                            className="form-textarea"
                                        />
                                    </Form.Item>
                                </Col>
                            </AntRow>

                            <Divider style={{ margin: '16px 0' }} />

                            <div className="modal-actions">
                                <Button
                                    onClick={onCancelAddAuthor}
                                    className="cancel-button"
                                    icon={<CloseOutlined />}
                                >
                                    Hủy
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="save-button"
                                    icon={<PlusOutlined />}
                                >
                                    Thêm dịch giả
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal>
            }
            {
                openModalEdit &&
                <CModalEditTranslator
                    open={openModalEdit}
                    data={author}
                    setOpenModalEdit={setOpenModalEdit}
                />
            }
            <div className="table-area">
                <CTable
                    tableMainTitle="Danh sách dịch giả"
                    allowTextSearch={true}
                    onChangeInput={onChangeInput}
                    onSearch={onSearch}
                    titleOfColumnList={columns}
                    data={listTranslator}
                    totalRecord={totalAuthorsRecords}
                    titleAddButton="Thêm dịch giả"
                    textSearch="Nhập tên dịch giả"
                    onChangePagination={onChangePagination}
                    allowAddObject={true}
                    pageSize={10}
                    size={450}
                    handleAddObject={() => setOpenModalAdd(true)}
                />
            </div>
        </motion.div >
    );
};

export default Translator;
